var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orderSummaryTotal
    ? _c(
        "section",
        [
          _c("div", { staticClass: "row no-gutters" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("message.my_reservations.summary_total.title"))
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters mt-1" }, [
            _c("div", { staticClass: "col-9" }, [
              _vm._v(
                _vm._s(_vm.$t("message.my_reservations.summary_total.subtotal"))
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-3 text-right" }, [
              _vm._v(
                "\n      " + _vm._s(_vm._f("currency")(_vm.subtotal)) + "\n    "
              )
            ])
          ]),
          _vm._v(" "),
          _vm.order.extra
            ? _c("div", { staticClass: "row no-gutters mt-1" }, [
                _c("div", { staticClass: "col-9" }, [
                  _vm._v(_vm._s(_vm._f("multiLangName")(_vm.order.extra)))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3 text-right" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("currency")(_vm.orderSummaryTotal.extra_cost)
                      ) +
                      "\n    "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.orderSummaryTotal.promo_code_usage &&
          _vm.orderSummaryTotal.promo_code_usage.applied
            ? _c("div", { staticClass: "row no-gutters mt-1" }, [
                _c("div", { staticClass: "col-9" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("message.my_reservations.summary_total.discount")
                      ) +
                      ":\n      " +
                      _vm._s(_vm.orderSummaryTotal.promo_code_usage.code) +
                      "\n      (" +
                      _vm._s(_vm.orderSummaryTotal.promo_code_usage.discount) +
                      "%)\n    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-3 text-right -status-discount" },
                  [
                    _vm._v(
                      "\n      -" +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.orderSummaryTotal.discount_cost
                          )
                        ) +
                        "\n    "
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.order.is_new_cost_format
            ? _c("section", [
                _vm.orderSummaryTotal.service_vat
                  ? _c("div", { staticClass: "row no-gutters mt-1" }, [
                      _c("div", { staticClass: "col-9" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.my_reservations.summary_total.service_vat"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.orderSummaryTotal.service_vat
                            )
                          )
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderSummaryTotal.credit_discount_cost
                  ? _c("div", { staticClass: "row no-gutters mt-1" }, [
                      _c("div", { staticClass: "col-9" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "message.my_reservations.summary_total.discount_credits"
                              )
                            ) +
                            "\n      "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-3 text-right -status-discount" },
                        [
                          _vm._v(
                            "\n        -" +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.orderSummaryTotal.credit_discount_cost
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            : _c("section", [
                _vm.orderSummaryTotal.credit_discount_cost
                  ? _c("div", { staticClass: "row no-gutters mt-1" }, [
                      _c("div", { staticClass: "col-9" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "message.my_reservations.summary_total.discount_credits"
                              )
                            ) +
                            "\n      "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-3 text-right -status-discount" },
                        [
                          _vm._v(
                            "\n        -" +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.orderSummaryTotal.credit_discount_cost
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderSummaryTotal.service_vat
                  ? _c("div", { staticClass: "row no-gutters mt-1" }, [
                      _c("div", { staticClass: "col-9" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.my_reservations.summary_total.service_vat"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.orderSummaryTotal.service_vat
                            )
                          )
                        )
                      ])
                    ])
                  : _vm._e()
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters mt-3" }, [
            _c("div", { staticClass: "col-9" }, [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("message.my_reservations.summary_total.total"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-3 text-right" }, [
              _c("label", [
                _vm._v(_vm._s(_vm._f("currency")(_vm.orderSummaryTotal.total)))
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.order.payment_data && _vm.order.total_price
            ? _c("div", { staticClass: "row no-gutters" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$options.filters.orderPaymentData(
                          _vm.order.payment_data
                        )
                      )
                    }
                  }),
                  _vm._v(" "),
                  !_vm.order.paid_status
                    ? _c(
                        "span",
                        { staticClass: "d-inline-block text-orange" },
                        [
                          _vm._v(
                            "\n        (" +
                              _vm._s(_vm.$t("message.all_pending")) +
                              ")\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.order.payment_method === "bank_transfer" &&
                  _vm.order.bank_transfer_data &&
                  _vm.order.bank_transfer_data.transfer_picture
                    ? _c("div", { staticClass: "text-center" }, [
                        _c("div", { staticClass: "py-3" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.order.bank_transfer_data.transfer_picture,
                                target: "_blank"
                              }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "rounded border border-gray shadow-sm",
                                attrs: {
                                  src:
                                    _vm.order.bank_transfer_data
                                      .transfer_picture,
                                  alt: "",
                                  height: _vm.$mq.phone ? 300 : 360
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.order.cancel === 0
                          ? _c(
                              "div",
                              { staticClass: "pb-2" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-small text-secondary text-left"
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.my_reservations.change_slip_image_remark"
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("vue-dropzone", {
                                  ref: "vueDropzone",
                                  staticClass: "dropzone-dashed",
                                  attrs: {
                                    id: "dropzone",
                                    options: _vm.dropzoneOptions
                                  },
                                  on: {
                                    "vdropzone-max-files-exceeded":
                                      _vm.vueDropZoneMaxFilesExceeded,
                                    "vdropzone-sending":
                                      _vm.vueDropZoneAddParams,
                                    "vdropzone-mounted": _vm.vueDropZoneMounted,
                                    "vdropzone-success": _vm.vueDropZoneSuccess
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.orderSummaryTotal.refund_cost ||
          _vm.orderSummaryTotal.returned_credits
            ? _c("section", { staticClass: "pb-2" }, [
                _c("hr"),
                _vm._v(" "),
                _vm.orderSummaryTotal.refund_cost
                  ? _c("div", { staticClass: "row no-gutters pt-1" }, [
                      _c("div", { staticClass: "col-9" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.my_reservations.summary_total.cancellation_refund"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.orderSummaryTotal.refund_cost
                            )
                          )
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderSummaryTotal.returned_credits
                  ? _c("div", { staticClass: "row no-gutters pt-1" }, [
                      _c("div", { staticClass: "col-9" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.my_reservations.summary_total.returned_credits"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-3 text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.orderSummaryTotal.returned_credits
                            )
                          )
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters mt-1 text-secondary" }, [
            _c("div", { staticClass: "col-6" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.my_reservations.created_at")) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 text-right" }, [
              _vm.order.created_at
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("prettyDate")(_vm.order.created_at)) +
                        "\n      "
                    )
                  ])
                : _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("prettyDate")(_vm.order.order_date)) +
                        "\n      "
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _vm.orderSummaryTotal.reconcile_date
            ? _c("div", { staticClass: "row no-gutters mt-1 text-secondary" }, [
                _c("div", { staticClass: "col-6" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("message.my_reservations.paid_at")) +
                      "\n    "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-right" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("prettyDate")(
                          _vm.orderSummaryTotal.reconcile_date
                        )
                      ) +
                      "\n    "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.displayAdditionalHours()
            ? [
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "row no-gutters" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.my_reservations.additional_hours")
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.order.book_more_hours, function(
                  orderAdditionalHours,
                  index
                ) {
                  return _c("div", [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("div", { staticClass: "flex-fill" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("message.my_reservations.additional_hours")
                            ) +
                            " #" +
                            _vm._s(orderAdditionalHours.id) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-fill text-right" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("currency")(
                                orderAdditionalHours.total_price
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex mt-1" }, [
                      _c("div", { staticClass: "flex-fill" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "message.my_reservations.summary_total.service_vat"
                              )
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-fill text-right" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("currency")(
                                orderAdditionalHours.service_vat
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex mt-3" }, [
                      _c("div", { staticClass: "flex-fill" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.my_reservations.summary_total.total"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-fill text-right" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                Number(orderAdditionalHours.total_price) +
                                  Number(orderAdditionalHours.service_vat)
                              )
                            )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    orderAdditionalHours.payment_data
                      ? _c("div", { staticClass: "d-flex" }, [
                          _c("div", { staticClass: "flex-fill" }, [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.orderPaymentData(
                                    orderAdditionalHours.payment_data
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            !_vm.order.paid_status
                              ? _c(
                                  "span",
                                  { staticClass: "d-inline-block text-orange" },
                                  [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.$t("message.all_pending")) +
                                        ")"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex mt-1 text-secondary" }, [
                      _c("div", { staticClass: "flex-fill" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("message.my_reservations.created_at")
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-fill text-right" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("prettyDate")(
                                orderAdditionalHours.created_at
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex mt-1" }, [
                      _c("div", { staticClass: "flex-fill text-secondary" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("message.my_reservations.status")) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-fill text-right" }, [
                        _c(
                          "span",
                          {
                            class: _vm.getOrderAdditionalHoursStatus(
                              orderAdditionalHours
                            ).textColor
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getOrderAdditionalHoursStatus(
                                    orderAdditionalHours
                                  ).status
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    orderAdditionalHours.is_declined &&
                    (orderAdditionalHours.payment_method === "bank_transfer" ||
                      orderAdditionalHours.payment_method === "promptpay")
                      ? _c("div", { staticClass: "pt-2" }, [
                          _vm._m(0, true),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-secondary" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "message.my_reservations.request_declined_remark"
                                  )
                                ) +
                                "\n        "
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index + 1 < _vm.order.book_more_hours.length
                      ? _c("hr")
                      : _vm._e()
                  ])
                })
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74147bf8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74147bf8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/OrderSummaryTotal.vue
// module id = 1745
// module chunks = 0